











import { computed, defineComponent, reactive } from '@vue/composition-api';

import Breadcrumb from '@/renderer/components/SpacePage/components/Breadcrumb.vue';
import linkList from '@/renderer/components/linkList/index.vue';
import { CrumbItem } from '@/renderer/components/SpacePage/list.vue';
import { SMH } from '@/renderer/scripts/smh';
import router from '@/renderer/router';
import i18n, { i18n_t } from '@/locales/i18n';
import { IS_BROWSER } from '@/common/constant/platform';
import storage from '@/renderer/scripts/utils/storage';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import store from '@/renderer/store';

export default defineComponent({
  components: { linkList, Breadcrumb },
  setup(props, context) {
    const vm = context.root;
    const groupSelected = computed(() => vm.$store.getters.drawerSelected?.[0]);

    const linkQueryParams = reactive<SMH.OrgShareListParams>({
      groupId: groupSelected.value.id,
    });
    const crumbs: CrumbItem[] = [
      {
        name: i18n_t('{slot1}外链管理', { slot1: groupSelected.value.name }),
        content: i18n_t('{slot1}外链管理', { slot1: groupSelected.value.name }),
        type: 'dir',
        disabled: false,
        path: '',
      },
    ];

    const methods = {
      changeBreadcrumbIndex(index: Number, name: String, backCrumb: boolean) {
        if (backCrumb) {
          if (!IS_BROWSER) {
            const routeBeforePreview = store.getters.previousRoute;
            if (!Object.keys(routeBeforePreview).length) {
              dispatchRouter({
                name: 'collaborationSpace',
              });
            } else {
              dispatchRouter({
                ...routeBeforePreview,
              });
            }
          } else {
            router.back();
          }
        }
      },
    };

    return {
      linkQueryParams,
      crumbs,
      methods,
    };
  },
});
